import { render, staticRenderFns } from "./CustomerEdition.vue?vue&type=template&id=a68a4b6c&"
import script from "./CustomerEdition.vue?vue&type=script&lang=js&"
export * from "./CustomerEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports